import HTTP from 'libs/http';
import { AccountType, PasswordType } from 'store/reducers/login';

class Login extends HTTP {
  async checkAccount({
    company_id,
    account,
    account_type
  }: {
    company_id?: number;
    account: string;
    account_type: AccountType;
  }) {
    return await this.post(`/account/check`, {
      company_id,
      account,
      account_type
    });
  }

  async sendSMS({
    company_id,
    account,
    account_type
  }: {
    company_id?: number;
    account: string;
    account_type: AccountType;
  }) {
    return await this.post(`/account/auth_code/send`, {
      company_id,
      account,
      account_type
    });
  }

  async login({
    company_id,
    account_type,
    auth_type,
    account,
    auth_code
  }: {
    company_id: number;
    account: string;
    account_type: AccountType;
    auth_type: PasswordType;
    auth_code: string;
  }) {
    return await this.post(`/account/login`, {
      company_id,
      account_type,
      auth_type,
      account,
      auth_code
    });
  }

  async setPassword({ new_password }: { new_password: string }) {
    return await this.post(`/account/setPassword`, {
      new_password
    });
  }

  async setPhone({ value, auth_code }: { value: string; auth_code: string }) {
    return await this.post(`/account/setPhone`, {
      value,
      auth_code
    });
  }

  async setEmail({ value, auth_code }: { value: string; auth_code: string }) {
    return await this.post(`/account/setEmail`, {
      value,
      auth_code
    });
  }

  async getAccountInfo() {
    return await this.post(`/account/basic_info/get`);
  }
}
export default new Login();
